function MenuItem({ name, price }) {
  return (
    <div className="menu-item-row">
      <span className="body-b1">{name}</span>
      {/* dash line */}
      <hr className="menu-item-divider" />
      <span className="body-b1">{price}</span>
    </div>
  );
}

export default MenuItem;
